
export const insertAfter = (newNode: Element, referenceNode: Element) => {
    if(referenceNode.parentNode){
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
};
